/**
 * Format text with markdown-style bold (**text**) to React elements
 * @param {string} text - Text that may contain **bold** markers
 * @returns {Array} Array of React elements (strings and <strong> elements)
 */
export const formatBoldText = (text) => {
  if (!text) return text;
  
  const parts = [];
  const regex = /\*\*(.+?)\*\*/g;
  let lastIndex = 0;
  let match;
  
  while ((match = regex.exec(text)) !== null) {
    // Add text before the bold marker
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    
    // Add the bold text
    parts.push(<strong key={match.index}>{match[1]}</strong>);
    
    lastIndex = regex.lastIndex;
  }
  
  // Add remaining text after last match
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  
  // If no matches, return original text
  return parts.length > 0 ? parts : text;
};

